import {jsx as _jsx} from "react/jsx-runtime";import graphql from 'babel-plugin-relay/macro'
import {useEffect} from 'react'
import {useFragment} from 'react-relay'
import { withRouter} from 'react-router'
import useAtmosphere from '~/hooks/useAtmosphere'

import {LocalStorageKey} from '../types/constEnums'
import TeamInvitationAccept from './TeamInvitationAccept'
import TeamInvitationEmailCreateAccount from './TeamInvitationEmailCreateAccount'
import TeamInvitationEmailSignin from './TeamInvitationEmailSignin'
import TeamInvitationErrorAccepted from './TeamInvitationErrorAccepted'
import TeamInvitationErrorExpired from './TeamInvitationErrorExpired'
import TeamInvitationErrorNotFound from './TeamInvitationErrorNotFound'
import TeamInvitationGoogleCreateAccount from './TeamInvitationGoogleCreateAccount'
import TeamInvitationGoogleSignin from './TeamInvitationGoogleSignin'
import TeamInvitationSSO from './TeamInvitationSSO'





const TeamInvitationDialog = (props) => {
  const {verifiedInvitation: verifiedInvitationRef, match} = props
  const verifiedInvitation = useFragment(
    graphql`
      fragment TeamInvitationDialog_verifiedInvitation on VerifiedInvitationPayload {
        ...TeamInvitationErrorAccepted_verifiedInvitation
        ...TeamInvitationErrorExpired_verifiedInvitation
        ...TeamInvitationGoogleSignin_verifiedInvitation
        ...TeamInvitationGoogleCreateAccount_verifiedInvitation
        ...TeamInvitationEmailSignin_verifiedInvitation
        ...TeamInvitationEmailCreateAccount_verifiedInvitation
        errorType
        isGoogle
        ssoURL
        user {
          preferredName
        }
      }
    `,
    verifiedInvitationRef
  )
  const {params} = match
  const {token: invitationToken} = params

  const atmosphere = useAtmosphere()
  useEffect(() => {
    window.localStorage.setItem(LocalStorageKey.INVITATION_TOKEN, invitationToken)
  }, [invitationToken])

  if (!verifiedInvitation) {
    // rate limit reached
    return _jsx(TeamInvitationErrorNotFound, {} )
  }
  const {errorType, isGoogle, user, ssoURL} = verifiedInvitation
  switch (errorType) {
    case 'notFound':
      return _jsx(TeamInvitationErrorNotFound, {} )
    case 'accepted':
      return _jsx(TeamInvitationErrorAccepted, { verifiedInvitation: verifiedInvitation,} )
    case 'expired':
      return _jsx(TeamInvitationErrorExpired, { verifiedInvitation: verifiedInvitation,} )
  }
  const {authToken} = atmosphere
  if (authToken) {
    return _jsx(TeamInvitationAccept, { invitationToken: invitationToken,} )
  }
  if (ssoURL) {
    return _jsx(TeamInvitationSSO, { ssoURL: ssoURL,} )
  }
  if (user) {
    return isGoogle ? (
      _jsx(TeamInvitationGoogleSignin, { verifiedInvitation: verifiedInvitation,} )
    ) : (
      _jsx(TeamInvitationEmailSignin, {
        invitationToken: invitationToken,
        verifiedInvitation: verifiedInvitation,}
      )
    )
  }
  return isGoogle ? (
    _jsx(TeamInvitationGoogleCreateAccount, {
      invitationToken: invitationToken,
      verifiedInvitation: verifiedInvitation,}
    )
  ) : (
    _jsx(TeamInvitationEmailCreateAccount, {
      invitationToken: invitationToken,
      verifiedInvitation: verifiedInvitation,}
    )
  )
}

export default withRouter(TeamInvitationDialog)
